<template>
    <VCheckbox v-bind="$attrs" :class="classList" v-on="$listeners">
        <template #label>
            <slot name="label" />
        </template>
    </VCheckbox>
</template>

<script>
// https://vuetifyjs.com/en/components/selection-controls#checkboxes-boolean
import { USER_INPUT_CLASS } from '../../utils/classNames';

const ELEMENT_CLASS = 'sr-checkbox';

export default {
    name: 'SrCheckbox',
    model: {
        prop: 'inputValue',
        event: 'change',
    },
    computed: {
        classList() {
            return [ELEMENT_CLASS, USER_INPUT_CLASS];
        },
    },
};
</script>

<style lang="scss" scoped>
.v-input {
    width: fit-content;
}
</style>
